import { SpecialProductProject } from "./special-product-project.model";

export class SpecialOfferModel {
  public id: string;
  public name: string;
  public description: string;
  public maxNumberOfVenuesForPrimaryProjects: number;
  public maxNumberOfVenuesForSecondaryProjects: number;
  public mounthlyPrice: number;
  public mounthlyProcessorProductId: string;
  public yearlyPrice: number;
  public yearlyProcessorProductId: string;
  public validUtilDate: Date | string;
  public countriesId: number[];
  public specialProductProjectsModel: SpecialProductProject[];
}
